<div class="container">
	<img src="assets/icons/x-close-bold.svg" (click)="dialogRef.close()" class="close"/>
	<img class="visual-aid" [src]="data.imageSrc">
</div>